import React from "react";
import TextOverflowEllipsis from "components/common/TextOverflowEllipsis";
import { Timestamp } from "components/common";
const DefaultColumnRenderers = {
  types: {
    DATE: {
      renderCell: (dateTime) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime }),
      staticWidth: 160
    },
    STRING: {
      renderCell: (text) => /* @__PURE__ */ React.createElement(TextOverflowEllipsis, null, text)
    }
  },
  attributes: {
    description: {
      width: 2
    },
    summary: {
      width: 1.5
    },
    favorite: {
      renderHeader: () => "",
      staticWidth: 30
    }
  }
};
export default DefaultColumnRenderers;
